import GuestPackages from '../ui/GuestPackages';
import { connect } from 'react-redux';
import { guestPackagesSubmit, skipSubmit, goBack } from '../../actions';

const mapStateToProps = (state, props) => ({
  page: state.page,
  intl: props.intl,
  user: state.user,
  content: state.content,
  profileElements: state.profileElements,
  activeProfileElements: state.activeProfileElements,
  requiredFields: state.requiredFields
})

const mapDispatchToProps = dispatch => ({
  onGuestPackagesSubmit(payload) {
    dispatch(guestPackagesSubmit(payload))
  },
  onSkipSubmit(payload) {
    dispatch(skipSubmit(payload))
  },
  onGoBack(payload) {
    dispatch(goBack(payload))
  }
})

const Container = connect(mapStateToProps, mapDispatchToProps)(GuestPackages);

export default Container;
